module.exports = __webpack_public_path__ + "img/caipanzi.931605e3.png";